import moment from 'moment';
import { useMemo } from 'react';
import seedrandom from 'seedrandom';

const CONSTS = {
    SEED: 'seed',
    SEED_CREATION: 'seedCreation'
};

export const useSessionRandom = () => {

    const seed = useMemo( () => {
        const storedSeed = sessionStorage.getItem( CONSTS.SEED );
        const storedCreationTime = sessionStorage.getItem( CONSTS.SEED_CREATION );

        // seed is recreated if seed is older than 5 minutes and a refresh
        if ( storedSeed && storedCreationTime && moment( storedCreationTime ).diff( moment(), 'minutes', true ) >= -5 ) {
            return storedSeed;
        }

        const newSeed = Math.random();
        sessionStorage.setItem( CONSTS.SEED, newSeed );
        sessionStorage.setItem( CONSTS.SEED_CREATION, moment().format() );

        return newSeed;
    }, [] );

    /**
     * example:
     * const rand = getSeededRandom()
     * rand() // will be same value every first time its called within 5 mintue session
     * 
     * @returns random function that is seeded for the 5 minute session
     */
    function getSeededRandom() {
        return seedrandom( seed );
    }

    return useMemo( () => ( {
        seed, getSeededRandom
    } ), [ seed ] );
};